<template>
  <div class="w-full flex flex-row bg-gray-200 mt-1 p-1">
    <div class="w-1/12 flex flex-row space-x-1">
      <span>
        <i class="mr-2 flag-icon" :class="currencyFlagIcon(value.caseCurrency)"/>
      </span>

      <span># {{ value.id }}</span>
    </div>

    <div class="w-1/12 flex justify-start items-center">
      <span class="truncate">
        {{ $t(`lists.caseStatus.${value.caseStatus}`) }}
      </span>
    </div>

    <div class="w-10/12 flex flex-row">
      <div class="w-1/5 flex justify-start items-center">
        <span class="truncate">
          {{ ownerName }}
        </span>
      </div>

      <div class="w-1/5 flex justify-start items-center px-2">
        <span class="truncate" v-if="value.patient">
          {{ value.patient.getDisplayName() }}
        </span>
      </div>

      <div class="w-1/5 flex justify-center items-center">
        {{ value.createdAt | to_date }}
      </div>

      <div class="w-1/5 flex justify-center items-center">
        {{ value.finishAt | to_date }}
      </div>

      <div class="w-1/5 flex justify-center items-center" v-if="!value.cancelled()">
        <vx-tooltip :text="$t('pages.cases.markAsSolved')" position="top" delay=".3s"
                    v-if="$store.state.Profile.isSupervisor() && value.isArchived() && !value.isClosed()">
          <feather-icon icon="PlayCircleIcon" class="cursor-pointer mx-1"
                        svg-classes="h-7 w-7 cursor-pointer p-1 rounded bg-gray-200 text-dark hover:bg-primary hover:text-white"
                        @click.stop="removeArchived(value.id)"/>
        </vx-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import {getLangByValue} from "@/helpers/lists";
import {showErrorNotify} from "@/helpers/functionsHelpers";

export default {
  name: "CaseHistorical",
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ownerName: null,
    }
  },
  methods: {
    currencyFlagIcon(currency) {
      return getLangByValue(currency).icon;
    },
    populateData() {
      this.$store.dispatch('Users/lookupUser', this.value.owner_id).then((response) => {
        this.ownerName = response.getDisplayName();
      }, error => {
        showErrorNotify(this, error);
      });
    },
    removeArchived(id) {
      this.$emit('removeArchived', id);
    }
  },
  mounted() {
    this.populateData();
  }
}
</script>

<style scoped>

</style>
